import React, { useEffect, useState } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import FormCategoriaPlatillo from "../../../components/menu/categoria/FormCategoriaPlatillo";
import Loader from "../../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import { formSchema } from "../../../validaciones/validacionCategoriaPlatillo";
const DetalleCategoriasPlatillo = () => {
  const [multiImagenes, handleChangeImagen] = useState([])
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
  const [estatus] = useState([{value:1,label:"Activo"},{value:2,label:"Oculto"}]);
  const navigate = useNavigate();
  const { id } = useParams();

  const [datos, setDatos] = useState({
    id,
    nombre:"",
    descripcion:"",
    estatus:1
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos({ ...datos, [name]: value });
  };

  useEffect(() => {

    function obtenerCategoria() {
      // eslint-disable-next-line
      if(id != 0){
        fetch(`/api/product-categories/${id}`,{
          method: "GET",
          headers:{
            "Content-Type": "application/json",
          },
        })
        .then((res) => res.json())
        .then(async (data) => {
          console.log(data);
          if(data.status){
            setDatos((x)=>({
              ...x,
              id,
              nombre:data.data.nombre || "",
              descripcion:data.data.descripcion || "",
              estatus:1
            }));
            if(data.data.imageUrl){
              handleChangeImagen([{
                id,
                nombre:data.data.imageKey || data.data.imageUrl,
                file:null,
                esNuevo:false,
                preview:data.data.imageUrl,
              }]);
            }
  
              
            

            setIsLoading(false);
          } 
        });
      }
      else{
        setIsLoading(false);
      }
    }

    obtenerCategoria()
  }, [id]);

  const handleSave = () => {
    const result = formSchema.safeParse({...datos/* ,multiImagenes:multiImagenes */});
    console.log(result);
    if (!result.success) {
      console.log(result.error.errors);
      console.log(result.error.flatten().fieldErrors);
      setError(result.error.flatten().fieldErrors)
      return;
    }
    else{
      setError(null)
    }

    const payload = {
      nombre: datos.nombre,
      descripcion: datos.descripcion || "",
    };
    const formData = new FormData();
    formData.append('datos', JSON.stringify(payload));
    const nuevaImagen = multiImagenes.find((imagen) => imagen.esNuevo && imagen.file);
    if (nuevaImagen) {
      formData.append('imagen', nuevaImagen.file);
    }
    // eslint-disable-next-line
    if (id == 0) {
      // Create new sucursal
      try {
        fetch("/api/product-categories",{
          method: "POST",
          body: formData
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    else {
      // Update sucursal
      try {
        fetch(`/api/product-categories/${id}`,{
          method: "PUT",
          body: formData
        })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if(data.status){
            // Success
            navigate(-1);
          }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }

  return (
    <>
      <MasterLayout>
        { isLoading ? 
          <Loader /> : 
          <FormCategoriaPlatillo 
            datos={datos} 
            handleChange={handleChange} 
            handleSave={handleSave}
            handleChangeImagen={handleChangeImagen}
            multiImagenes={multiImagenes}
            estatus={estatus}
            error={error}
          />
        }
      </MasterLayout>
    </>
  );
};

export default DetalleCategoriasPlatillo;
